// plugins/clarity.client.ts
export default defineNuxtPlugin(() => {
  if (!process.client) return;

  const { clarityId, clarityEnabled } = useRuntimeConfig().public as {
    clarityId?: string;
    clarityEnabled?: boolean;
  };
  if (!clarityEnabled || !clarityId) return;

  const loadClarity = () => {
    (function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', clarityId);
  };

  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadClarity);
  } else {
    setTimeout(loadClarity, 0);
  }
});
